@if (user$ | async; as user) {
  <zah-header
    [menuEnabled]="user.authenticated"
    (menuClick)="sidenav.toggle()">
  </zah-header>
  <zah-sidenav #sidenav
    [user]="user">
    <router-outlet></router-outlet>
  </zah-sidenav>
  <zah-footer></zah-footer>
}
